import DashboardCard from "../../../ISSB/Dashboard/components/DashboardCard";
import LocalSpinner from "../../../../components/LocalSpinner";
import { Box, Flex, Heading, Text } from "@chakra-ui/react";
import { getFormattedNumValue } from "../../../../utils";
import { TrendDown, TrendUp } from "@phosphor-icons/react";
import { useNavigate } from "react-router-dom";
import { routes } from "../../../../config";

const DataQualityCard = ({ isLoading, currentYear, previousYear, theme = "light" }) => {
  const navigate = useNavigate();
  const colors = {
    light: {
      cardBg: "#F7FAFC",
      title: "teal",
      value: "gray.800",
      percentUp: "status.green",
      percentDown: "status.red",
    },
    dark: {
      cardBg: "pureBlack",
      title: "pureWhite",
      value: "lightLime",
      percentUp: "status.green",
      percentDown: "status.red",
    },
  };
  const t = colors[theme] || colors.light;

  const totalSuppliersWithData = currentYear?.totalSuppliersWithData || 0;
  const supplierCountWithRequestedData = currentYear?.supplierCountWithRequestedData || 0; // prevent division by zero
  const totalSuppliersWithDataPercentage = // this is supplier with any data finalized
    supplierCountWithRequestedData > 0 ? (totalSuppliersWithData / supplierCountWithRequestedData) * 100 : 0;

  const totalSuppliersWithAllFinalized = currentYear?.totalSuppliersWithAllFinalizedData || 0;
  const totalSuppliersWithDataPercentageFinalized = // this is supplier with everything finalized
    supplierCountWithRequestedData > 0 ? (totalSuppliersWithAllFinalized / supplierCountWithRequestedData) * 100 : 0;

  // this is supplier that have incomplete data (in progress) = sup with requested - sup with all data
  const totalSuppliersWithIncompleteData = supplierCountWithRequestedData - totalSuppliersWithAllFinalized;
  const totalSuppliersWithIncompleteDataPercentage =
    supplierCountWithRequestedData > 0 ? (totalSuppliersWithIncompleteData / supplierCountWithRequestedData) * 100 : 0;

  const verifiedSupplierCount = currentYear?.verifiedSupplierCount || 0;
  const verifiedSupplierPercentage =
    totalSuppliersWithData > 0 ? (verifiedSupplierCount / totalSuppliersWithData) * 100 : 0;

  let basePercentageChange = 0;
  if (previousYear && previousYear.totalSuppliersWithData) {
    const previousSuppliersWithData = previousYear?.totalSuppliersWithData || 0;
    basePercentageChange = ((totalSuppliersWithData - previousSuppliersWithData) / previousSuppliersWithData) * 100;
  }

  return (
    <DashboardCard bg={t.cardBg} px={6} onClick={() => navigate(routes.supplierInsightsEngagement)}>
      <Text fontSize="body.m" fontWeight="bold" color={t.title}>
        Data Quality
      </Text>
      {isLoading ? (
        <LocalSpinner size="sm" />
      ) : (
        <Flex direction="column" gap={8} height="100%" justify="space-between">
          <Box direction="column" gap={8} mb={4}>
            <Heading fontSize="heading.2xl" py={2}>
              <Text as="span" fontSize="heading.2xl" fontWeight="bold" color={t.value}>
                {getFormattedNumValue(totalSuppliersWithDataPercentageFinalized, 2) || 0} %
              </Text>{" "}
              <Text as="span" fontSize="body.m" color={t.value}>
                finalized
              </Text>
            </Heading>

            <Heading fontSize="heading.2xl" py={2}>
              <Text as="span" fontSize="heading.2xl" fontWeight="bold" color={t.value}>
                {getFormattedNumValue(totalSuppliersWithIncompleteDataPercentage, 2) || 0} %
              </Text>{" "}
              <Text as="span" fontSize="body.m" color={t.value}>
                in progress
              </Text>
            </Heading>

            <Heading fontSize="heading.2xl" py={2}>
              <Text as="span" fontSize="heading.2xl" fontWeight="bold" color={t.value}>
                {getFormattedNumValue(verifiedSupplierPercentage, 2) || 0} %
              </Text>{" "}
              <Text as="span" fontSize="body.m" color={t.value} mt={4}>
                verified
              </Text>
            </Heading>
          </Box>


          <Box mt={4}>
            <Flex
              direction="row"
              width="100%"
              // px="15%"
              justifyContent="space-between"
            >
              <Text
                display="flex"
                gap={1}
                color={basePercentageChange >= 0 ? t.percentUp : t.percentDown}
                fontSize="heading.s"
                fontWeight="bold"
              >
                {basePercentageChange >= 0 ? (
                  <TrendUp size={18} weight="bold" />
                ) : (
                  <TrendDown size={18} weight="bold" />
                )}
                {getFormattedNumValue(basePercentageChange, 2) || 0} %
              </Text>
            </Flex>
          </Box>
        </Flex>
      )}
    </DashboardCard>
  );
};

export default DataQualityCard;
